import { api_fetch_throws } from "./client"

export type KrogerProductReviewStatus = "pending" | "approved" | "rejected"

export interface KrogerProductReviewItem {
  product_description: string
  status: KrogerProductReviewStatus
  backup_row_count: number
  deduction_count: number
  total_amount: number
  sample_upcs: string[]
}

export interface KrogerProductReviewListResponse {
  items: KrogerProductReviewItem[]
}

export interface KrogerProductReviewUpdate {
  product_description: string
  status: Exclude<KrogerProductReviewStatus, "pending">
}

export interface ApplyRejectedProductsSummary {
  deductions_marked: number
  total_dispute_amount: number
}

export interface SaveKrogerProductReviewResponse {
  summary: ApplyRejectedProductsSummary
}

export async function list_kroger_product_review(): Promise<KrogerProductReviewListResponse> {
  return api_fetch_throws<KrogerProductReviewListResponse>("/integration/kroger/product-review")
}

export async function save_kroger_product_review(
  updates: KrogerProductReviewUpdate[]
): Promise<SaveKrogerProductReviewResponse> {
  return api_fetch_throws<SaveKrogerProductReviewResponse>("/integration/kroger/product-review", {
    method: "POST",
    body: { updates },
  })
}
